var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ShowIf from "../../App/ShowIf";
import { Field, Control } from 'react-redux-form';
import { t } from "../../I18N";
import { advancedSort } from "../../utils/advancedSort";
import nestedProperties from "../../Templates/components/ViolatedArticlesNestedProperties";
import { store } from "../../store";
import { Icon } from "../../UI";
import { MultiSelect } from "./MultiSelect";

export default class NestedMultiselect extends Component {
  constructor(props) {
    super(props);
    const values = this.props.value || {};
    this.state = { values, filter: '' };
    if (!Object.keys(this.state.values).length) {
      this.state.values = props.property.nestedProperties.reduce((result, prop) => {
        result[prop.key] = [];
        return result;
      }, {});
    }
  }

  onChange(key, optionsSelected) {
    const values = _objectSpread(_objectSpread({}, this.state.values), {}, { [key]: optionsSelected });

    this.setState({ values });
    this.props.onChange(values);
  }

  getOptions(prop, aggregations) {
    if (this.props.options) {
      return this.props.options;
    }

    if (!aggregations.all[this.props.property.name][prop]) {
      return [];
    }
    let options = aggregations.all[this.props.property.name][prop].buckets;
    if (options.length === 1 && options[0].key === 'missing') {
      return [];
    }
    options = options.
    map((item) => ({
      label: item.key,
      value: item.key,
      results: item.filtered.total.filtered.doc_count
    })).
    filter((option) => option.results);
    return advancedSort(options, {
      property: 'value',
      treatAs: 'dottedList',
      listTypes: [Number, Number, String]
    });
  }

  resetFilter() {
    this.setState({ filter: '' });
  }

  filter(e) {
    this.setState({ filter: e.target.value });
  }

  selectAnyChange(key, e) {
    const values = _objectSpread(_objectSpread({}, this.state.values), {}, { [key]: [], [`${key}any`]: e.target.checked });
    this.setState({ values });
    this.props.onChange(values);
  }

  toggleOptions(key, e) {
    e.preventDefault();
    const state = {};
    state[key] = !this.state[key];
    this.setState(state);
  }

  render() {
    const { property } = this.props;
    const { locale } = store.getState();
    const aggregations = this.props.aggregations ? this.props.aggregations.toJS() : {};
    return /*#__PURE__*/(
      _jsx("ul", { className: "multiselect is-active" }, void 0, /*#__PURE__*/
      _jsx("li", { className: "multiselectActions" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx(Icon, {
        icon: this.state.filter ? 'times-circle' : 'search',
        onClick: this.resetFilter.bind(this) }
      ), /*#__PURE__*/
      _jsx("input", {
        className: "form-control",
        type: "text",
        placeholder: t('System', 'Search item', null, false),
        value: this.state.filter,
        onChange: this.filter.bind(this) }
      )
      )
      ),
      (() =>
      property.nestedProperties.map((prop, index) => {
        const options = this.getOptions(prop, aggregations);
        if (!options.length) {
          return false;
        }
        const label = nestedProperties[prop.toLowerCase()] ?
        nestedProperties[prop.toLowerCase()][`label_${locale}`] :
        prop;
        return /*#__PURE__*/(
          _jsx("li", {}, index, /*#__PURE__*/
          _jsx(Field, { model: `.filters.${property.name}.properties.${prop}.any` }, void 0, /*#__PURE__*/
          _jsx("div", { className: "multiselectItem" }, void 0, /*#__PURE__*/
          _jsx("input", {
            type: "checkbox",
            className: "form-control multiselectItem-input",
            id: prop.key,
            onChange: this.selectAnyChange.bind(this, prop) }
          ), /*#__PURE__*/
          _jsx("label", { htmlFor: prop, className: "multiselectItem-label" }, void 0, /*#__PURE__*/
          _jsx("span", { className: "multiselectItem-icon" }), /*#__PURE__*/
          _jsx("span", { className: "multiselectItem-name", title: label }, void 0, /*#__PURE__*/
          _jsx("b", {}, void 0, label)
          )
          ), /*#__PURE__*/
          _jsx("span", { className: "multiselectItem-results" }, void 0, /*#__PURE__*/
          _jsx("span", {
            className: "multiselectItem-action",
            onClick: this.toggleOptions.bind(this, prop) }, void 0, /*#__PURE__*/

          _jsx(Icon, { icon: this.state[prop] ? 'caret-up' : 'caret-down' })
          )
          )
          )
          ), /*#__PURE__*/
          _jsx(ShowIf, { if: this.state[prop] }, void 0, /*#__PURE__*/
          _jsx(Control, {
            component: MultiSelect,
            model: `.filters.${property.name}.properties.${prop}.values`,
            prefix: property.name + prop,
            options: options,
            onChange: this.onChange.bind(this, prop),
            showAll: true,
            hideSearch: true,
            sortbyLabel: true,
            filter: this.state.filter }
          )
          )
          ));

      }))()
      ));

  }
}

NestedMultiselect.defaultProps = {
  value: {},
  options: undefined
};